import { Space } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem, MensajeError } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ordenProduccionCierrePdf from "../../../../Pdf/ordenProduccionCierrePdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalPdfCierreOrdenPU extends Component {
  iframeRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
    folio: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible && this.props.ordenId) {
        this.consultarDatosPdf();
      } else if (!this.props.visible) {
        this.setState({ pdf: null, folio: null });
      }
    }
  }

  consultarDatosPdf() {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/datosPdfCierre",
        { ordenId: this.props.ordenId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          MensajeError({ message: res.data.error || "No se pudo generar el PDF de cierre" });
          this.setState({ loading: false });
          return;
        }
        const pdf = pdfMake.createPdf(ordenProduccionCierrePdf(res.data));
        this.setState({ loading: false, pdf, folio: res.data.orden?.folio }, () => this.abrirEnIframe(pdf));
      })
      .catch(() => {
        MensajeError({ message: "Hubo un error y no se pudo generar el PDF de cierre" });
        this.setState({ loading: false });
      });
  }

  abrirEnIframe(pdf, intento = 0) {
    const frame = this.iframeRef.current?.contentWindow || window.frames["OrdenProduccionCierrePdfIframe"];
    if (frame) {
      pdf.open({}, frame);
      return;
    }
    if (intento < 10) {
      setTimeout(() => this.abrirEnIframe(pdf, intento + 1), 100);
    }
  }

  descargarPdf() {
    if (this.state.pdf) {
      this.state.pdf.download(`OrdenProduccion_${this.state.folio || "cierre"}.pdf`);
    }
  }

  handleCancel = () => {
    this.props.onCancel();
  };

  render() {
    return (
      <ModalItem
        title={`Cierre de orden${this.state.folio ? " — " + this.state.folio : ""}`}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.handleCancel}
        paddingTop
        width={900}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
          <Space>
            <ButtonItem icon={<DownloadOutlined />} type="primary" disabled={!this.state.pdf} onClick={() => this.descargarPdf()}>
              Descargar PDF
            </ButtonItem>
            <ButtonItem rojo onClick={this.handleCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>
        <iframe
          ref={this.iframeRef}
          title="Cierre Orden Producción PDF"
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="OrdenProduccionCierrePdfIframe"
          name="OrdenProduccionCierrePdfIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalPdfCierreOrdenPU);
